<template>
  <sn-modal
    v-model="showModal"
    type="decision"
    :title="title"
    data-cy="error-overflow-modal"
    primary-text="Close"
    secondary-text="Copy text"
    secondary-icon="$snCopy"
    @submit="handleClose"
    @secondarySubmit="handleCopy"
  >
    <pre>
      {{ message }}
    </pre>
  </sn-modal>
</template>

<script>

export default {
  name: 'srErrorOverflowModal',
  props: {
    toggleModal: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  watch: {
    toggleModal () {
      this.showModal = this.toggleModal
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleCopy () {
      navigator.clipboard.writeText(this.message)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

@import '~/assets/css/snui';

pre {
  white-space: pre-line;
  word-wrap: break-word;
  word-break: break-word;
}

</style>
